import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import MediaQuery from 'react-responsive'
import { Checkbox } from '@unowmooc/react-ui-kit'
import Row from '../Row'
import Cell from '../Cell'
import DragControl from '../DragControl'

import styles from './styles.module.scss'

class RowData extends Component {
  get regularCells() {
    const { children } = this.props

    const regularChildren = React.Children.map(children, child => child)

    return regularChildren.filter(child => _.get(child, 'type.type') !== 'action')
  }

  get actionCell() {
    const { children } = this.props

    const actionChildren = React.Children.map(children, child => child)

    return actionChildren.find(child => _.get(child, 'type.type') === 'action')
  }

  render() {
    const {
      data,
      labels,
      innerRef,
      draggableProps,
      dragHandleProps,
      selected,
      dragging,
      dataGridDragging,
      onSelectRow,
      withReorder,
    } = this.props

    const { regularCells, actionCell } = this

    return (
      <Row
        {...draggableProps}
        innerRef={innerRef}
        className={classnames(styles.rowData, {
          [styles.selected]: selected,
          [styles.dragging]: dragging,
          [styles.dataGridDragging]: dataGridDragging,
        })}
      >
        {actionCell && (
          <MediaQuery maxWidth={480}>
            <div className={styles.mobileActionCell}>
              {React.cloneElement(actionCell, { ...actionCell.props, data })}
            </div>
          </MediaQuery>
        )}

        {withReorder && (
          <Cell
            width={20}
            verticalAlign="top"
            render={() => <DragControl {...dragHandleProps} dragging={dragging} />}
            className={styles.cellDragControl}
          />
        )}

        {onSelectRow && (
          <Cell
            width={20}
            verticalAlign="top"
            render={() => <Checkbox checked={selected} onChange={isChecked => onSelectRow(data, isChecked)} />}
            className={styles.cellSelect}
          />
        )}

        {regularCells.map((child, index) => React.cloneElement(child, { ...child.props, data, label: labels[index] }))}

        {actionCell && (
          <MediaQuery minWidth={481}>{React.cloneElement(actionCell, { ...actionCell.props, data })}</MediaQuery>
        )}
      </Row>
    )
  }
}

RowData.defaultProps = {
  onSelectRow: undefined,
  innerRef: undefined,
  draggableProps: {},
  dragHandleProps: {},
  selected: false,
  dragging: false,
  dataGridDragging: false,
  withReorder: false,
}

RowData.propTypes = {
  data: PropTypes.shape({}).isRequired,
  labels: PropTypes.node.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  innerRef: PropTypes.func,
  draggableProps: PropTypes.shape({}),
  dragHandleProps: PropTypes.shape({}),
  selected: PropTypes.bool,
  dragging: PropTypes.bool,
  dataGridDragging: PropTypes.bool,
  onSelectRow: PropTypes.func,
  withReorder: PropTypes.bool,
}

export default RowData
